import { render, staticRenderFns } from "./InfluencerTransferDataTable.vue?vue&type=template&id=1a2afd98&"
import script from "./InfluencerTransferDataTable.vue?vue&type=script&lang=js&"
export * from "./InfluencerTransferDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports